module.exports = __webpack_public_path__ + "static/detecht-hero-b1f4dba161b2e68504c52679c427f41f.jpg";